// extracted by mini-css-extract-plugin
export default {"image":"ClassImage-module__image","loaded":"ClassImage-module__loaded"};